import React, { useState } from 'react'
import { Col, Row, Dropdown, Container, Offcanvas } from 'react-bootstrap'
import { NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import LogoutModal from '../Modals/LogoutModal';
import { IoPersonCircleOutline } from "react-icons/io5";

function Header({ title }) {

    //modal
    const [showLogout, setShowLogout] = useState(false);

    const handleCloseLogout = () => setShowLogout(false);
    const handleShowLogout = () => setShowLogout(true);

    const dispatch = useDispatch();
    const switcher = useSelector(state => state?.reducer?.switcher)
    const [mobSearch, setMobSearch] = useState(false)

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const setSwitcher = (val) => {
        dispatch({
            type: "switching",
            value: { switcher: val }
        })
    }

    return (
        <>
            <div className='header mt-2 py-2 px-2 position-relative'>

                <Row className='align-items-center'>
                    <Col xl={6} lg={4} md={4} xs={8} className='d-flex gap-3'>
                        <p className='header_title d-block d-xl-none' onClick={handleShow}><i class="fa-solid fa-bars" /></p>
                        <p className='header_title'>{title}</p>
                    </Col>
                    <Col xl={6} lg={8} md={8} xs={4} className='d-flex justify-content-end align-items-center gap-3'>
                        <div className='header_profileImg_holder'>
                            <div className='d-flex align-items-center gap-2'>
                                <p className='mb-0 text-white'>Admin</p>
                            <Dropdown className='header_profile_drop' drop='down'>
                                <Dropdown.Toggle variant="success" id="dropdown-basic">
                                    <IoPersonCircleOutline className='svgsize'/>
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item className='rounded-2' href='/user'>Profile</Dropdown.Item>
                                    <Dropdown.Item className='rounded-2' onClick={handleShowLogout}>Logout</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>

                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            {/* offcanva content */}
            <Offcanvas show={show} onHide={handleClose} backdrop="static" className='header_canvas'>
                <Offcanvas.Body>
                    <div className='header_canva_header pb-2 d-flex justify-content-between align-items-center'>
                        <img src={require('../assets/images/logo.png')} className='img-fluid' />
                        <button className='cmn_modal_closer rounded-5' onClick={handleClose}><i class="fa-solid fa-xmark" /></button>
                    </div>
                    <ul className="pt-4">
                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/grid.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Dashboard</p>
                            </NavLink>
                        </li>

                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/tokenList' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/grid2.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Tokens</p>
                            </NavLink>
                        </li>

                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/userList' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/grid3.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Users</p>
                            </NavLink>
                        </li>
                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/categorylist' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/user.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Category</p>
                            </NavLink>
                        </li>

                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/faqList' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/grid5.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Faq List</p>
                            </NavLink>
                        </li>

                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/subscriberlist' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/grid6.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Subscriber Lists</p>
                            </NavLink>
                        </li>

                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/subscriberadd' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/grid7.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Newsletter</p>
                            </NavLink>
                        </li>
                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/cmslist' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/grid8.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">CMS Management</p>
                            </NavLink>
                        </li>
                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/purchasedlist' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/grid9.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Sales Report Management</p>
                            </NavLink>
                        </li>
                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/reportlist' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/grid10.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Report Management</p>
                            </NavLink>
                        </li>
                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/nfttag' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/grid11.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">NFT Share Tag Management</p>
                            </NavLink>
                        </li>
                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/settings' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/grid12.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Social Links</p>
                            </NavLink>
                        </li>
                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/editserviceFee' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/grid13.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Service Fee Management</p>
                            </NavLink>
                        </li>
                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/user' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/grid14.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">User Profile</p>
                            </NavLink>
                        </li>
                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/plannedUser' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/prime.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Planned User</p>
                            </NavLink>
                        </li>
                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/subscriptionadd' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/plan.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Subscription Plans</p>
                            </NavLink>
                        </li>
                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/Domains' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/grid2.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Campaign</p>
                            </NavLink>
                        </li>
                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/SBT' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/grid2.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">SBT Tokens</p>
                            </NavLink>
                        </li>
                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/Collection' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/grid2.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Bulk Collection</p>
                            </NavLink>
                        </li>
                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/RevenueDetails' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/user.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Revenue</p>
                            </NavLink>
                        </li>
                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/categorylistSBT' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/gridlast1.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">SBT Category</p>
                            </NavLink>
                        </li>
                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/categorylistFractional' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/gridlast1.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Fractional Category</p>
                            </NavLink>
                        </li>
                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/editserviceFraction' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/user.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Service Fee Fractions</p>
                            </NavLink>
                        </li>
                        <li className="rounded-end-5 mb-3">
                            <NavLink to='/ListCustomtoken' className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/gridlast.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">TokenList</p>
                            </NavLink>
                        </li>
                        <li className="rounded-end-5" onClick={handleShowLogout}>
                            <NavLink className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                                <img src={require('../assets/images/logout.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Logout</p>
                            </NavLink>
                        </li>

                    </ul>
                </Offcanvas.Body>
            </Offcanvas>
            {/* end of offcanva content */}

            {/* modals */}
            <LogoutModal show={showLogout} handleClose={handleCloseLogout} />
            {/* end of modals */}

            
        </>
    )
}

export default Header